// ============================================
// 프롬프트 스토어 — DB 이관 프롬프트 단일 접근점
// ============================================
// useAiChat이 /prompts fetch 후 setPromptMap(promptKey→DTO)으로 채움.
// React 훅·AgentSession(클래스)·aiPrompts(함수) 어디서나 resolvePrompt(key, 상수)로
// DB 텍스트 우선 + 상수 fallback. {placeholder} 치환은 호출처 잔류(텍스트만 DB).
//
// 미적재(백엔드 미배포/해당 key 없음) 시 fallback 상수 → 거동 불변(byte-faithful).

let _promptMap = {};

// promptKey 기준 DB 프롬프트 맵 등록 (useAiChat fetch 시 1회) //
export function setPromptMap(map) {
  _promptMap = map || {};
}

// DB 텍스트 우선, 없으면 상수 fallback //
export function resolvePrompt(key, fallback) {
  return _promptMap[key]?.text ?? fallback;
}
